import React, { createContext, useContext } from 'react';

/**
 * TabContext
 * - 현재 선택된 탭 상태 관리
 * - tab: TAB_BASIC | TAB_BUDGET | TAB_FAVORITE
 */
const TabContext = createContext(null);

/**
 * TabProvider
 * @param {Object} value - { tab, setTab }
 */
export const TabProvider = ({ children, value }) => {
  return <TabContext.Provider value={value}>{children}</TabContext.Provider>;
};

/**
 * useTabContext
 * - TabProvider 내부에서만 사용 가능
 * - tab, setTab 반환
 */
export const useTabContext = () => {
  const context = useContext(TabContext);
  if (!context) {
    throw new Error('useTabContext는 TabProvider 내부에서 사용해야 합니다');
  }
  return context;
};

export default TabContext;
